import "./titlePage.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import { useSelector } from "react-redux";


const TitlePage = () => {
  const roofInfo = useSelector((state) => state.roof)
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`;
  };
  
  const currentDate = getCurrentDate();
  let titleData = [
    {
      title: "Project address:",
      data: roofInfo.value.siteAddress.value,
    },
    {
      title: "Customer Name:",
      data: roofInfo.value.customerName
    },
    {
      title: "Issue date:",
      data: `${currentDate}`,
    },
  ];

  return (
    <div className="title-page">
      {/* Background Image */}
      <div className="background-image" />
      {/* Patterns */}
      <img
        className="pattern-1"
        src="../images/report/pattern.svg"
        alt="pattern"
      />
      <img
        className="pattern-2"
        src="../images/report/pattern.svg"
        alt="pattern"
      />
      {/* Header */}
      <Header/>
      {/* Main Body */}
      <main className="title-page-body">
        <h1>Site Details</h1>
        <table>
          <tbody>
            {titleData.map((item) => {
              return (
                <tr key={item.title}>
                  <td className="t-heading">{item.title}</td>
                  <td className="t-body">{item.data}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
      {/* Footer */}
      <Footer/>
    </div>
  );
};

export default TitlePage;
